/* eslint-disable */
import styles from './style.module.scss';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/back.svg';
import { t } from '@web-solutions/module-localization';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import Button from 'src/onboarding/components/ui/button/Button';
import Analytics from '@web-solutions/module-analytics';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import getLocale from 'src/localization/get-locale';

function DynamicTransition({ pageConfig, onNext, onPrev }) {
  const { currentIndex } = useNav();
  const locale = getLocale();

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{pageConfig.title[locale]}</Title>
        {pageConfig.subTitle && <Text semibold className={styles.description}>{pageConfig.subTitle[locale]}</Text>}
      </div>
      <div className={styles.continue}>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: pageConfig.id,
            });
            onNext();
          }}
          title={t('onboarding.analyzeBody.continue')}
        />
      </div>
    </div>
  );
}

export default DynamicTransition;
